(() => {
  const header = document.querySelector('[data-site-header]');
  const toggle = document.querySelector('[data-mobile-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  const overlay = document.querySelector('[data-mobile-menu-overlay]');
  const closeButton = document.querySelector('[data-mobile-menu-close]');
  const desktopDropdowns = Array.from(document.querySelectorAll('[data-desktop-dropdown]'));
  if (!header) return;

  const closeMobileMenu = () => {
    if (!toggle || !menu || !overlay) return;
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open menu');
    menu.hidden = true;
    overlay.hidden = true;
    document.documentElement.classList.remove('mobile-menu-open');
  };

  const openMobileMenu = () => {
    if (!toggle || !menu || !overlay) return;
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'Close menu');
    menu.hidden = false;
    overlay.hidden = false;
    document.documentElement.classList.add('mobile-menu-open');
    menu.querySelector('a, summary, button')?.focus();
  };

  toggle?.addEventListener('click', () => {
    if (toggle.getAttribute('aria-expanded') === 'true') closeMobileMenu();
    else openMobileMenu();
  });
  overlay?.addEventListener('click', closeMobileMenu);
  closeButton?.addEventListener('click', closeMobileMenu);
  menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMobileMenu));

  desktopDropdowns.forEach((dropdown) => {
    dropdown.addEventListener('toggle', () => {
      if (!dropdown.open) return;
      desktopDropdowns.forEach((other) => {
        if (other !== dropdown) other.open = false;
      });
    });
  });

  document.addEventListener('click', (event) => {
    desktopDropdowns.forEach((dropdown) => {
      if (dropdown.open && !dropdown.contains(event.target)) dropdown.open = false;
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeMobileMenu();
    desktopDropdowns.forEach((dropdown) => { dropdown.open = false; });
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 780) closeMobileMenu();
  });
})();
